<template>
  <fin-dialog v-if="hasOpenInvoices"
              v-model="dialog"
              :fullscreen="$vuetify.breakpoint.xs"
              :max-width="700"
              content-class="fin-open-invoices-dialog"
              style="overflow: hidden;"
              @input="(val) => {if (val === false){dialog = false}}">
    <template #title>
      Offene Rechnungen
    </template>

    <p>
      Eine offene Rechnung liegt vor.
    </p>

    <p v-if="openInvoicesDueDatePast">
      Dein Konto wurde gesperrt, da deine offene Rechnung nicht beglichen wurde.
      <span v-if="profile">Die Zahlungsfrist war {{ profile.paymentDeadline | date }}.</span>
    </p>
    <p v-else>
      Solltest du deine offene Rechnung bis
      <span v-if="profile">zum {{ profile.paymentDeadline | date }}</span>
      <span v-else>zur Frist</span>
      nicht beglichen haben, wird dein Konto gesperrt.
    </p>

    <p>
      Bitte passe deine Zahlungsdaten an,
      oder setze dich bei Fragen zur Zahlung oder zum Abo mit unserem Support
      <a href="mailto:support@fincraft.de">support@fincraft.de</a> in Verbindung.
    </p>
    <p v-if="openInvoicesDueDatePast">
      Nach Erhalt deiner Zahlung wirst du für das Abo {{ groupPriceModel.id }} freigeschaltet.
    </p>

    <template #actions>
      <v-btn v-if="!isApp"
             @click="navigateToStripePaymentPortalLink">
        Zu deinen Rechnungen
      </v-btn>
      <p v-else>
        Auf <a :href="paymentsWebUrl">fincraft.de</a> hast du Zugriff auf deine Rechnungen und kannst deine
        Zahlungsinformationen einsehen und gegebenenfalls
        anpassen.
      </p>
    </template>
  </fin-dialog>
</template>


<script>

import {mapGetters} from "vuex"
import Stripe from "@/mixins/Stripe"
import BaseUrl from "@/mixins/BaseUrl"
import finBrowser from "@/js/finBrowser"

export default {
  name: "FinPaymentStatusCheck",
  components: {},
  data() {
    return {
      dialog: false,
      paymentsWebUrl: undefined,
      isApp: finBrowser.IS_IOS_OR_ANDROID_APP
    }
  },
  mixins: [Stripe, BaseUrl],
  computed: {
    ...mapGetters('auth', ['profile', 'groupPriceModel']),
    hasOpenInvoices() {
      return this.profile && this.profile.paymentStatus === 'open'
    },
    openInvoicesDueDatePast() {
      const today = new Date()
      const todayMs = new Date(`${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`).getTime()
      const openInvoicesDueDate = this.profile ? new Date(this.profile.paymentDeadline).getTime() : undefined
      return openInvoicesDueDate ? todayMs > openInvoicesDueDate : false
    }
  },
  watch: {
    hasOpenInvoices(newVal) {
      this.dialog = newVal
    }
  },
  mounted() {
    this.dialog = this.hasOpenInvoices

    this.paymentsWebUrl = this.getBaseURL() + "/protected/myProfile/payments"
  },
}
</script>

<style lang="scss" scoped>

</style>
